/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { ButtonPro, Container, ContentLeft, ContentRight, Text } from "./styles";

import { FaTrashAlt } from "react-icons/fa";

import "./style.css"
import { useState } from "react";
import { useEffect } from "react";


const CardCurso = ({ myKey, onClick, curso, pos, code, ano, type, typePos , name, register, setValue }) => {
    const [typeName, setTypeName] = useState('');

    function setType() {
        if (typePos === 1) {
            setTypeName('Especialização')
        }
        else if (typePos === 2) {
            setTypeName('Mestrado')
        }
        else if (typePos === 3) {
            setTypeName('Doutorado')
        }
    }

    useEffect(() => {
        setType()
    }, [typePos])

    return (
        <Container key={myKey}
            name={name}
            {...register}
            {...setValue}
        >
            <ContentLeft>
                <ButtonPro type={type} key={myKey} className="button-curso" onClick={onClick}>
                    <FaTrashAlt color="red" />
                </ButtonPro>
            </ContentLeft>
            <ContentRight style={{ marginLeft: 20 }}>
                <Text>{curso ? `Curso Superior: ${curso}` : `Pós: ${pos}`}</Text>
                <Text style={{ marginTop: 10 }}>{code ? `IES: ${code}` : `tipo: ${typeName}`}</Text>
                <Text style={{ marginTop: 10 }}>Conclusão:{ano}</Text>
            </ContentRight>
        </Container>
    )

}
export default CardCurso;